import axios from 'axios'

axios.defaults.headers.common['X-CSRF-Token'] = document.head.querySelector('[name=csrf-token]')?.content

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.reload()
      return Promise.reject(error)
    }
    if (error.response?.status === 403 || error.response?.status === 404) {
      const errorMessage = error.response?.data?.error
      const redirectPath = error.response?.data?.redirect_path

      if (redirectPath) {
        sessionStorage.setItem('flash_error', errorMessage)
        window.location.href = redirectPath
      }

      // Return a promise that never resolves to prevent catch handlers from executing
      return new Promise(() => {})
    }
    return Promise.reject(error)
  }
)

const axios_api = axios

export default axios_api
